module.exports = __webpack_public_path__ + "static/media/AddDriversTemplate.c2cb31fb.csv";